import { render, staticRenderFns } from "./Cajaadmin.vue?vue&type=template&id=40d56962&"
import script from "./Cajaadmin.vue?vue&type=script&lang=js&"
export * from "./Cajaadmin.vue?vue&type=script&lang=js&"
import style0 from "./Cajaadmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports